export const GET_VIDEO_SUCCESS = 'GET_VIDEO_SUCCESS';
export const GET_VIDEO_ERROR = 'GET_VIDEO_ERROR';
export const GET_VIDEO_LOADING = 'GET_VIDEO_LOADING';
export const VIDEO_FILTER_SUCCESS = 'VIDEO_FILTER_SUCCESS';
export const SEARCH_DATA = 'SEARCH_DATA';
export const HAS_FILTER_VIDEO = 'HAS_FILTER_VIDEO';
export const UPLOAD_VIDEO_SUCCESS = 'UPLOAD_VIDEO_SUCCESS';
export const RESET_INITIAL_STATE = 'RESET_INITIAL_STATE';
export const IS_UPLOADING_VIDEO = 'IS_UPLOADING_VIDEO';
export const SET_UPLOADING_PERCENTAGE = 'SET_UPLOADING_PERCENTAGE';

export const VIDEO_DETAIL_SUCCESS = 'VIDEO_DETAIL_SUCCESS';
export const VIDEO_COMMENTS_LOADING = 'LOADING_VIDEO_COMMENTS';
export const VIDEO_COMMENTS_SUCCESS = 'SUCCESS_VIDEO_COMMENTS';
export const POST_NEW_COMMENT_LOADING = 'POST_NEW_COMMENT_LOADING';
export const ADD_NEW_COMMENT = 'ADD_NEW_COMMENT';
export const REMOVE_COMMENT = 'REMOVE_COMMENT';
export const SET_DELETE_COMMENT_LOADING = 'SET_DELETE_COMMENT_LOADING';
